const AvailabilityStatusTypes = Object.freeze({

  DEPARTED: {
    code: 'TRAIN DEPARTED'
  },
  NOTAVAILABLE: {
    code: 'NOT AVAILABLE'
  },
  REGRET: {
    code: 'REGRET'
  },
  TRAIN_CANCELLED: {
    code: 'TRAIN CANCEL'
  },
  CLASS_NOT_EXIST: {
    code: 'CLASS NOT EXIST'
  }
});

export default AvailabilityStatusTypes;
